import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  selectedLang = new BehaviorSubject<string>(
    localStorage.getItem('lang') || 'en'
  );

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(this.selectedLang.value);
    this.translate.use(this.selectedLang.value);
  }

  setLanguage(lang: string) {
    this.selectedLang.next(lang);
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }
}
